import _mergeJSXProps from './node_modules/@vue/babel-helper-vue-jsx-merge-props/dist/helper.mjs';

var BagHelpBgIcon = {
  name: 'BagHelpBgIcon',
  props: {},
  functional: true,
  render(h, ctx) {
    const attrs = ctx.data.attrs || {};
    ctx.data.attrs = attrs;
    return h("svg", _mergeJSXProps([{
      "attrs": {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 148 148"
      },
      "class": "c-ficon c-ficon--bag-help-bg"
    }, ctx.data]), [h("path", {
      "attrs": {
        "d": "m10.7 29.3 16.6 88.6 111.1-68.1L10.7 29.3Z",
        "fill": "#DEE8A3"
      }
    }), h("path", {
      "attrs": {
        "d": "m54.8 51.3 1.7-5.7 13-1.3L81 43.1s17 .5 20.6.5l11.9.2s-1 10.6-2 16.7L109 74.9l-9.2 24.7-42.2 1.7-15.9-2.5L48.2 84l5.5-28.1 5.6-3.3s-3-1.8-4.5-1.3Z",
        "fill": "#fff"
      }
    }), h("path", {
      "attrs": {
        "d": "M54.9 49s-7.4 1-11.3 2.2a49.3 49.3 0 0 0-15 7.6 53.7 53.7 0 0 0-8.4 9.3l-2.3 5s4-5 6-6.4c2.1-1.4 3.9-3 6.6-4.1 2.8-1.1 6.8-3 9.4-3.2 2.6-.3 6.9-1.8 9.4-2.6s10-4.2 10-4.2l-4.8-1.3.4-2.2Z",
        "fill": "#C9ECF2"
      }
    }), h("path", {
      "attrs": {
        "d": "M18.4 73.4s3.2-5.7 7.4-8 10-4.9 12.8-5.7l11.2-3 4.2-1.5-4.6 21.4-1.2 7s-1-.6-3.3 0-4 .5-5.4-.4c-1.4-.9-1.7-3.3-2.7-4.5-1-1.3-2-3.2-5.4-1.4-3.5 1.9-6.8 3.4-9.5 2.1-2.8-1.2-3.6-4.9-3.5-6Z",
        "fill": "#82C9E3"
      }
    }), h("path", {
      "attrs": {
        "d": "m41.4 98.8 6.4-14.1L50 73.6l4-18.4s3.1-1.4 5.3-2.6c0 0-1.1-.9-4.5-.9l1.3-6s8.7-.3 13.5-1.4L62 81.9l-.6 5.1-4 14.5s-12.9-1.1-16.1-2.7Z",
        "fill": "#FF8000"
      }
    }), h("path", {
      "attrs": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "m96.5 78.5-3-4.3v-3.8c0-.2-.1-.4-.3-.5l-.9-.5c-.3-.1-.7 0-.8.4l-.2 1.4-.4-.6a15.6 15.6 0 0 0-1.8-2.2c-.8-.8-1.6-.8-2.6-.4a32.5 32.5 0 0 0-11.3 9.2.6.6 0 0 0 .1.9c.8.6 1.8 1 2.8 1-.5 2-.8 4-.8 6 0 1.3.9 1.4 1.9 1.4h.2l1.4.2c.2-1.7.5-3.3.9-5h-.3c-.6-.3-.8-1-.9-1.6l.3-1.9V78l.6-2.2c.2-.5 1-.3.8.2l-.5 2v.3l-.2.5a.4.4 0 0 1 0 .2l.1.1.3.2a4.2 4.2 0 0 0 .4.2l.9-3.7c.1-.5.9-.3.7.2a98 98 0 0 0-.8 3.5c.4 0 .7 0 1-.2l1-3.3c0-.5.9-.3.7.2l-.3 1.1-.7 2.5a5.3 5.3 0 0 1-.7 1.6 1 1 0 0 1-.9.4 7.4 7.4 0 0 1-.4 0c-.1 1.7-.3 3.4-.6 5l1.4.1 3.5.2.6-2.6h-.4c-.3 0-.5 0-.8-.2a.6.6 0 0 1-.3-.3.4.4 0 0 1-.1-.4 14.9 14.9 0 0 1 3.6-7.6c.1-.4.8-.4.8 0V76.4a88 88 0 0 1-.9 8l-.4 2.8c.7 0 1.6-.2 2.2-.5 1-.5 1.1-1.6 1.3-2.5v-.4l.8-4c.9 0 1.8 0 2.6-.4.3 0 .6-.5.4-.8Zm-20-1v-.2.2Zm6.5-3.7h.1Zm7.3-2.1.9 1.2.2.3-1.1-1.5Zm2 .8v.1-.2a.6.6 0 0 1 0 .1Z",
        "fill": "#FF8000"
      }
    }), h("path", {
      "attrs": {
        "d": "M113 44.3a398.8 398.8 0 0 1-4.8 29.6c-.2 1 1.4 1.4 1.6.4a405 405 0 0 0 4.8-30c.1-1-1.5-1-1.6 0Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "m108.2 74.2-8.9 24.4c-.3 1 1.2 1.4 1.6.4l8.9-24.4c.3-1-1.2-1.4-1.6-.4Zm5.3-31.3L96 42.5c-5.5-.2-11.1-.4-16.7-.1-3.2.2-6.3.5-9.4 1-1 .3-.6 1.8.5 1.6 5.4-1 11-1.2 16.5-1.1 5.6 0 11.3.3 16.9.5l9.6.3c1 0 1-1.6 0-1.6Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M70 43.3c-4.5.7-9 1.2-13.5 1.5-1 0-1 1.7 0 1.6 4.7-.3 9.3-.8 14-1.6 1-.1.5-1.7-.5-1.5ZM53 55.7c-2.2 9.2-4 18.6-5.6 28-.2 1 1.4 1.5 1.5.5A473.3 473.3 0 0 1 54.5 56c.3-1-1.3-1.5-1.5-.5Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M55.3 45.9 54 51c-.2 1 1.3 1.5 1.6.4l1.3-5.2c.2-1-1.3-1.4-1.6-.4Zm-8 37.6c-1.9 5-4 10-6.3 14.9-.4 1 1 1.7 1.4.8 2.3-5 4.5-10 6.5-15.2.4-1-1.1-1.4-1.5-.4Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M41.6 99.8c5.3 1.2 10.7 2 16.1 2.5 1 .1 1-1.5 0-1.6-5.2-.5-10.5-1.3-15.6-2.5-1-.2-1.5 1.3-.4 1.5Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M57.7 102.5a1067.2 1067.2 0 0 0 42.1-2c1-.1 1-1.8 0-1.7a1053.4 1053.4 0 0 1-42 2c-1.1.1-1.1 1.7 0 1.7Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M58.3 101.5c1-3.7 2-7.2 3.2-10.8.3-1-1.2-1.4-1.6-.4-1.1 3.5-2.2 7.1-3.1 10.7-.3 1 1.3 1.5 1.5.5ZM68.8 44a218.3 218.3 0 0 0-2.6 14c-.2 1 1.4 1.5 1.5.5.7-4.7 1.6-9.4 2.7-14 .2-1.1-1.4-1.5-1.6-.5Zm-7 35.1-.9 4.2c-.2 1 1.4 1.4 1.6.4l.8-4.1c.2-1-1.3-1.5-1.5-.5ZM96.9 43a42 42 0 0 0-3.1-6.4c-.5-.9-2 0-1.4.8a39.4 39.4 0 0 1 3 6c.3 1 1.9.6 1.5-.4Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "m93 36.1-12.1.1c-1 0-1 1.6 0 1.6H93c1 0 1-1.7 0-1.7Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "m79.9 37.6 3.5 5.2c.6.9 2 0 1.4-.8l-3.5-5.2c-.6-.8-2 0-1.4.8Zm10.6 4.5-2.7-2.6c-.7-.7-1.8.4-1.1 1.1l2.6 2.7c.8.7 2-.4 1.2-1.1Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M87.2 39.2c-4.1 0-8.2 0-12.3.3-1 .1-1 1.7 0 1.7 4-.3 8.2-.4 12.3-.4 1 0 1-1.6 0-1.6Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "m74.2 40.8 2.2 2.7c.7.7 1.8-.5 1.1-1.2a18.5 18.5 0 0 1-1.9-2.3c-.6-.8-2 0-1.4.8Zm7 60a662.8 662.8 0 0 1-2.5 14.2c-.2 1 1.4 1.5 1.6.5l2.4-14.3c.2-1-1.4-1.5-1.5-.4Zm-7.9.4c-.3 2.1-1.2 4.8-3 6.1a3.4 3.4 0 0 1-5.4-2c-.3-1-1.8-.5-1.6.5a5 5 0 0 0 7 3.4c2.8-1.3 4.2-4.8 4.6-7.6.1-1-1.4-1.4-1.6-.4Zm39-41.3c2.2-1.3 4.6-2 7-2.7 2.4-.8 4.8-1.7 7.1-2.7 1-.4.2-1.8-.8-1.4a93 93 0 0 1-7.4 2.7c-2.3.8-4.6 1.5-6.7 2.7-.9.5 0 2 .8 1.4Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M125.9 52c-.7.8-1 1.8-.5 2.7.3.4.8.6 1.3.6s1-.3 1.3-.8c.5-.7.5-1.8-.2-2.4-.7-.5-1.8-.4-2.2.4-.1.4-.1.9.3 1.1.4.2 1 .2 1.1-.2 0-.2-.3 0-.1 0h-.1c.1 0 0 0 0 0-.2 0 0-.1 0 0l-.2.2v.1h.1v-.2c.2 0 .2-.2.3-.3.3-.3.3-.8 0-1.1-.3-.3-.8-.3-1.1 0Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M127.5 53.3c0-.2.2-.4.4-.5a.3.3 0 0 1 .2 0s0-.1 0 0c0 .2-.1.5-.4.6-1 .3-.6 1.8.4 1.5 1.3-.4 2-1.8 1.3-3a1.6 1.6 0 0 0-1.8-.7c-.7.2-1.1.7-1.5 1.2-.3.4 0 1 .3 1.1.4.3.8.1 1-.2Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M129.3 52.9h-.4v.4l-.3.4-.1.1a.8.8 0 0 0-1.1.3c-.2.4-.1 1 .3 1.1 1.4.7 2.5-.6 2.8-1.9.1-.6 0-1.4-.6-1.7-.6-.4-1.3-.3-1.7.1-.7.8.4 2 1.1 1.2Zm-72.5 5c-4.5.3-9.9 3.9-10.8 8.5-.4 2.3.2 4.9 2.5 6 2.4 1 5 0 7.1-1.3.9-.6 0-2-.8-1.4-1.6 1-3.7 2-5.6 1.2-1.9-.9-2-3.2-1.4-5 1.2-3.4 5.4-6.1 9-6.3 1 0 1-1.7 0-1.6Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M55.4 68.8c-1 .2-1.3 1.3-1.3 2.1 0 1 .7 2 1.8 1.9 1.1 0 1.8-1 1.8-2.1 0-1-.6-2.2-1.7-2-2.2 0-2.3 3.8 0 3.9 1 0 1.8-.6 1.9-1.6 0-1-.8-2.2-1.9-2.2-1.4 0-1.5 2-1 2.9.7.9 2.3.8 2.6-.4.3-1-1.3-1.4-1.5-.4 0-.2.1-.2.2-.2 0 0 0 .1 0 0v-.4c.1-.1.1-.1 0 0l-.4.1.3.2v.3s-.1.1-.2 0c-.2 0-.1-.6 0-.7v.2a.9.9 0 0 1 .1.3c0 .2 0 .4-.3.5 0 0-.1 0 0 0v-.9s-.2 0 0 0c1-.2.6-1.7-.4-1.5Zm3.5-16.9c-10.6 6.2-23.8 5.8-34 13a31.1 31.1 0 0 0-7.2 7.3c-.6.8.8 1.6 1.4.8 3.5-5 8.6-8.6 14.3-10.7 5.6-2.2 11.5-3.3 17.2-5 3.2-1 6.3-2.3 9.1-4 1-.5.1-2-.8-1.4Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M18.7 72.8a39.2 39.2 0 0 1 25.8-21 51 51 0 0 1 10.3-1.7c1 0 1-1.6 0-1.6a45.2 45.2 0 0 0-32.4 15.3 36.2 36.2 0 0 0-5.1 8.1c-.4 1 1 1.8 1.4.9Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M17.1 72.5a7.5 7.5 0 0 0 10.5 7.7c2.3-1 4.6-3.2 7.3-2.5 1.4.4 1.7 1.6 2 2.9a5.8 5.8 0 0 0 2 3.2 5.2 5.2 0 0 0 3.8 1c1.6-.1 3.2-1 4.7-.6 1 .3 1.5-1.2.5-1.5-2.5-.8-5 1.5-7.4.2-2.5-1.3-1.7-4.5-3.7-6-1.8-1.4-4.3-1-6.2 0C28 78 26 79.7 23 79a6 6 0 0 1-4.4-6.5c.1-1-1.5-1-1.6 0Zm42.7-20.7c-2.6-1.2-5.4-1-8.2-.4-3 .5-6 1.5-8.8 2.7-1 .4-.1 1.8.8 1.4a38.3 38.3 0 0 1 7.8-2.5c2.5-.5 5.2-.9 7.6.2 1 .5 1.8-1 .8-1.4Zm26-1.6c.7 0 .7-1.1 0-1.1s-.7 1.1 0 1.1Zm12.6.2h.3a.4.4 0 0 0 .2-.1l.1-.2a.4.4 0 0 0 0-.2v-.2a.6.6 0 0 0-.1-.2l-.1-.1a.6.6 0 0 0-.3-.1h-.1a.4.4 0 0 0-.2 0 .5.5 0 0 0-.3.3.4.4 0 0 0 0 .3v.4h.2l.3.1Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M82.5 50.4c-.6 1.3-.4 2.9 1 3.6 1.3.7 2.6 0 3.4-1.1.4-.5-.5-1-.8-.5-.5.7-1.3 1.2-2.2.8-.8-.5-1-1.5-.6-2.3.3-.5-.6-1-.8-.5ZM90 19.7a40 40 0 0 0 1.8-7.3c.2-1.2-1.5-1.6-1.7-.5a39.5 39.5 0 0 1-1.8 7.4c-.4 1 1.4 1.5 1.7.4Zm21.3 3.4c.5-1.6 1-3 1.8-4.6.5-1-1-1.9-1.5-.9a35.6 35.6 0 0 0-2 5c-.4 1.1 1.3 1.6 1.7.5Zm17.1 13.6c2.4-1.5 4.6-3 6.8-4.7 1-.7 0-2.2-.9-1.5-2.2 1.6-4.4 3.2-6.8 4.7-1 .6 0 2.1 1 1.5ZM22 117.1 25 115c1-.7 0-2.2-.9-1.5l-3.1 2.2c-1 .7 0 2.2.9 1.5Zm21.9 8.7a98 98 0 0 0-3.1 7.4c-.4 1 1.3 1.5 1.7.4.9-2.3 1.9-4.7 3-7 .4-1-1.1-1.9-1.6-.9Zm24.4 3.4-1 6.5c-.3 1.1 1.5 1.6 1.6.5l1-6.6c.3-1-1.4-1.6-1.6-.4Z",
        "fill": "#FF8000"
      }
    })]);
  }
};

export { BagHelpBgIcon as default };
